"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var markdown_1 = require("./__fixtures__/markdown");
Object.defineProperty(exports, "standard", { enumerable: true, get: function () { return markdown_1.standard; } });
tslib_1.__exportStar(require("./parse"), exports);
tslib_1.__exportStar(require("./parser"), exports);
//# sourceMappingURL=index.js.map